// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.LABEL_SET_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.labelSets.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
